<template>
  <div :class="{ 'has-bottom': showBottom }">
    <!-- 文档|白板 -->
    <!-- <component v-if="[0, 1].includes(leftToolType)" :is="currentTabComponent">
      <PseudoControl v-show="avctl" slot="bottom" />
      <AsideTool />
    </component> -->
    <Doc v-if="leftToolType === 0" key="a">
      <PseudoControl v-show="avctl" slot="bottom" />
    </Doc>
    <Whiteboard v-if="leftToolType === 1" key="b">
      <PseudoControl v-show="avctl" slot="bottom" />
    </Whiteboard>
    <AsideTool />
    <!-- 伪直播 -->
    <PseudoLive />
    <!-- 多媒体 -->
    <MultiMedia />
    <!-- 倒计时 -->
    <CountDown />

    <!-- 仅主播有以下功能 -->
    <template v-if="role === 3">
      <!-- 商品 -->
      <Goods />
      <!-- 推荐 -->
      <Recommend/>
      <!-- 公告 -->
      <Notice />
      <!-- 抽奖 -->
      <LuckDraws />
      <!-- 口令抽奖 -->
      <PasswordLuckDraws />
      <!-- 答题 -->
      <AnswerSheet />
      <!-- 问卷 -->
      <Answer />
      <!-- 红包 -->
      <RedPacket />
    </template>
    <!-- 签到 -->
    <SignIn />
    <subMix v-if="isShowMix"></subMix>
    <div class="stopShare pointer" @click="closeShare" v-if="openCloseShare">{{$t('acenter.停止共享')}}</div>
    <!-- 嘉宾连麦提示 -->
    <!-- <LianmaiTips v-if="role !== 3" /> -->
    <BigVideo />
    <!-- 分组控制-->
    <Group/>
  </div>
</template>
<script>
// 文档
import Doc from "@/components/doc/index";
// 白板
import Whiteboard from "@/components/whiteboard/index";
// 商品
import Goods from "@/components/toolList/goods";
// 推荐
import Recommend from "@/components/toolList/recommend";
// 签到
import SignIn from "@/components/toolList/signIn";
// 公告
import Notice from "@/components/toolList/notice";
// 抽奖
import LuckDraws from "@/components/toolList/luckDraws";
// 口令抽奖
import PasswordLuckDraws from "@/components/toolList/passwordLuckDraws";
// 伪直播
import PseudoLive from "@/components/pseudoLive";
// 多媒体
import MultiMedia from "@/components/multimedia";
// 控制条
import PseudoControl from "@/components/pseudoLive/control";
// 侧边工具条
import AsideTool from "./aside-left-sub.vue";
import subMix from "@/components/onLineUserList/controller/submix";
// 问卷
import Answer from "@/components/toolList/questionnaire";
// 答题
import AnswerSheet from "@/components/toolList/answer";
import CountDown from "@/components/toolList/countDown";
import RedPacket from "@/components/toolList/redPacket";
import Role from "@/mixins/role";
import Bus from "@/components/doc/bus";
import { mapState } from "vuex";
import LianmaiTips from "@/components/lianmai/tips.vue";
import BigVideo from "@/components/collapsed/sidebar.vue";
// 分组控制
import Group from "@/components/group";

export default {
  components: {
    Doc,
    Whiteboard,
    Goods,
    subMix,
    SignIn,
    Notice,
    LuckDraws,
    PasswordLuckDraws,
    PseudoLive,
    MultiMedia,
    PseudoControl,
    AsideTool,
    Answer,
    AnswerSheet,
    LianmaiTips,
    CountDown,
    RedPacket,
    BigVideo,
    Group,
    Recommend
  },
  mixins: [Role],
  data() {
    return {
      openCloseShare: false,
    };
  },
  created() {
    this.init();
  },
  computed: {
    ...mapState("docInfo", ["showBottom"]),
    leftToolType() {
      return this.$store.getters.leftToolType;
    },
    isShowMix() {
      return this.$store.getters.isShowMix;
    },
    currentTabComponent() {
      return this.leftToolType === 0 ? Doc : Whiteboard;
    },
    rtcClient() {
      return this.$store.getters.rtcClient;
    },
  },
  methods: {
    init() {
      Bus.$on("startShare", () => {
        this.openCloseShare = true;
      });
      Bus.$on("closeShareBtn", () => {
        this.openCloseShare = false;
      });
    },
    closeShare() {
      Bus.$emit("closeShare");
      this.openCloseShare = false;
      this.rtcClient.RTCRoom.unPublishShareScreen();
      if (this.rtcClient.RTCRoom.webrtc.publishShare.shareStream && this.rtcClient.RTCRoom.webrtc.publishShare.shareStream.getTracks) {
        this.rtcClient.RTCRoom.webrtc.publishShare.shareStream.getTracks().forEach((track) => {
          track.stop();
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.center {
  background: $center-back-color;
}
.stopShare {
    position: absolute;
    top: 18px;
    right: 18px;
    z-index: 999;
    width: 100px;
    height: 36px;
    line-height: 36px;
    background: #ea494b;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.2);
    color: #fff;
    font-size: 12px;
    border-radius: 6px;
}
</style>
